import { Injectable } from '@angular/core';
import { AbstractDataServiceDtoAdapter } from 'src/app/modules/core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {SaleRetrocessionModel} from "../../../api/entity/saleRetrocession.model";
import {SaleRetrocessionConverter} from "../../../api/entity/converter/saleRetrocession.converter";
import {SaleRetrocessionDataService} from "./sale-retrocession-data.service";


@Injectable()
export class SaleRetrocessionDataServiceAdapter extends AbstractDataServiceDtoAdapter<SaleRetrocessionModel, SaleRetrocessionConverter> {
    constructor(dataService: SaleRetrocessionDataService, converter: SaleRetrocessionConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): SaleRetrocessionModel {
        return new SaleRetrocessionModel();
    }
}